// src/services/authService.js
import api from './api';

export const authService = {
  login: async (credentials) => {
    // Backend очаква точно username и password
    const loginData = {
      username: credentials.username,
      password: credentials.password
    };
    
    // console.log('Sending login request to /api/auth/login:', loginData);
    
    try {
      const response = await api.post('/auth/login', loginData);
      // console.log('Login API response:', response.data);
      
      // Проверка на отговора
      if (response.data.token && response.data.user) {
        return response;
      } else {
        throw new Error('Invalid response format from server');
      }
    } catch (error) {
      console.error('Login service error:', error.response?.data || error.message);
      
      // Подобрена обработка на грешки
      if (error.response) {
        const serverError = error.response.data;
        throw {
          message: serverError.message || serverError.error || 'Грешка при влизане',
          status: error.response.status
        };
      } else if (error.request) {
        throw {
          message: 'Няма връзка със сървъра',
          status: 0
        };
      } else {
        throw {
          message: error.message || 'Неизвестна грешка',
          status: -1
        };
      }
    }
  },

  logout: () => {
    // console.log('Logging out...');
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  },

  getCurrentUser: async () => {
    const token = localStorage.getItem('token');
    const user = localStorage.getItem('user');
    
    if (!token) {
      throw new Error('Няма активна сесия');
    }
    
    // Връщаме от localStorage
    return {
      token,
      user: user ? JSON.parse(user) : null
    };
  },

  getToken: () => {
    return localStorage.getItem('token');
  },

  isAuthenticated: () => {
    const token = localStorage.getItem('token');
    return !!token;
  },

  isAdmin: () => {
    const user = localStorage.getItem('user');
    if (!user) return false;
    
    try {
      const userData = JSON.parse(user);
      // Вашият бекенд връща role като string, не roles array
      return userData.role === 'ADMIN' || userData.roles?.includes('ADMIN');
    } catch (error) {
      console.error('Error parsing user data:', error);
      return false;
    }
  }
};